module.exports = __webpack_public_path__ + "img/daffodil-howtospotcancerearly.b8b3793e.png";